import { render, staticRenderFns } from "./ShowNews.vue?vue&type=template&id=01ef40d0&scoped=true"
import script from "./ShowNews.vue?vue&type=script&lang=js"
export * from "./ShowNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ef40d0",
  null
  
)

export default component.exports